export const matchingDefaultContent = {
    en: {
        matchingTexts: {
            1: {
                question: 'Question 1',
                matching: 'Matching 1',
            },
            2: {
                question: 'Question 2',
                matching: 'Matching 2',
            },
        }
    },
    es: {
        matchingTexts: {
            1: {
                question: 'Pregunta 1',
                matching: 'Coincidencia 1',
            },
            2: {
                question: 'Pregunta 2',
                matching: 'Emparejando 2',
            },
        }
    }
}
